const initialState = {
  requestingFetchSubCategories: false,
  successfulFetchSubCategories: false,
  errorFetchSubCategories: false,
  subCategories: null,
  subCategoriesActive: [],
  requestingCreateSubCategory: false,
  successfulCreateSubCategory: false,
  errorsCreateSubCategory: false,
  subCategory: null,
  requestingReadSubCategory: false,
  successfulReadSubCategory: false,
  errorsReadSubCategory: false,
  rowEdited: null,
  requestingUpdateSubCategory: false,
  successfulUpdateSubCategory: false,
  errorsUpdateSubCategory: false,
  rowUpdated: null,
  lastFetchParams: null
};

const subCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_SUB_CATEGORIES_REQUEST":
      return {
        ...state,
        lastFetchParams: action.value || state.lastFetchParams
      };
    case "FETCH_SUB_CATEGORIES_REQUESTING":
      return {
        ...state,
        requestingFetchSubCategories: true,
        successfulFetchSubCategories: false,
        errorFetchSubCategories: false,
      };
    case "FETCH_SUB_CATEGORIES_SUCCESS":
      return {
        ...state,
        errorFetchSubCategories: false,
        requestingFetchSubCategories: false,
        successfulFetchSubCategories: true,
        subCategories: action.value,
      };
    case "FETCH_SUB_CATEGORIES_ERROR":
      return {
        ...state,
        errorFetchSubCategories: true,
        requestingFetchSubCategories: false,
        successfulFetchSubCategories: false,
      };
    case "CREATE_SUB_CATEGORY_REQUESTING":
      return {
        ...state,
        requestingCreateSubCategory: true,
        successfulCreateSubCategory: false,
        errorsCreateSubCategory: false,
      };
    case "CREATE_SUB_CATEGORY_SUCCESS":
      return {
        ...state,
        errorsCreateSubCategory: false,
        requestingCreateSubCategory: false,
        successfulCreateSubCategory: true,
        subCategory: action.value,
      };
    case "CREATE_SUB_CATEGORY_ERROR":
      return {
        ...state,
        errorsCreateSubCategory: true,
        requestingCreateSubCategory: false,
        successfulCreateSubCategory: false,
      };
    case "READ_SUB_CATEGORY_REQUESTING":
      return {
        ...state,
        requestingReadSubCategory: true,
        successfulReadSubCategory: false,
        errorsReadSubCategory: false,
      };
    case "READ_SUB_CATEGORY_SUCCESS":
      return {
        ...state,
        errorsReadSubCategory: false,
        requestingReadSubCategory: false,
        successfulReadSubCategory: true,
        rowEdited: action.value,
      };
    case "READ_SUB_CATEGORY_ERROR":
      return {
        ...state,
        errorsReadSubCategory: true,
        requestingReadSubCategory: false,
        successfulReadSubCategory: false,
      };
    case "UPDATE_SUB_CATEGORY_REQUESTING":
      return {
        ...state,
        requestingUpdateSubCategory: true,
        successfulUpdateSubCategory: false,
        errorsUpdateSubCategory: false,
      };
    case "UPDATE_SUB_CATEGORY_SUCCESS":
      return {
        ...state,
        errorsUpdateSubCategory: false,
        requestingUpdateSubCategory: false,
        successfulUpdateSubCategory: true,
        rowUpdated: action.value,
      };
    case "UPDATE_SUB_CATEGORY_ERROR":
      return {
        ...state,
        errorsUpdateSubCategory: true,
        requestingUpdateSubCategory: false,
        successfulUpdateSubCategory: false,
      };
    case "CHANGE_STATE_SUB_CATEGORY_REQUESTING":
      return {
        ...state,
        requestingUpdateSubCategory: true,
        errorsUpdateSubCategory: false,
        successfulUpdateSubCategory: false,
      };
    case "CHANGE_STATE_SUB_CATEGORY_SUCCESS":
      return {
        ...state,
        errorsUpdateSubCategory: false,
        requestingUpdateSubCategory: false,
        successfulUpdateSubCategory: true,
      };
    case "CHANGE_STATE_SUB_CATEGORY_ERROR":
      return {
        ...state,
        errorsUpdateSubCategory: true,
        requestingUpdateSubCategory: false,
        successfulUpdateSubCategory: false,
      };
    case "RESET_SUB_CATEGORY_FORM":
      return {
        ...state,
        requestingCreateSubCategory: false,
        successfulCreateSubCategory: false,
        errorsCreateSubCategory: false,
        subCategory: null,
        requestingReadSubCategory: false,
        successfulReadSubCategory: false,
        errorsReadSubCategory: false,
        rowEdited: null,
        requestingUpdateSubCategory: false,
        successfulUpdateSubCategory: false,
        errorsUpdateSubCategory: false,
        rowUpdated: null,
      };
    case "GET_ALL_ACTIVE_SUB_CATEGORIES_REQUESTING":
      return {
        ...state,
        requestingGetActiveSubCategories: true,
        successfulGetActiveSubCategories: false,
        errorGetActiveSubCategories: false,
        subCategoriesActive: []
      };
    case "GET_ALL_ACTIVE_SUB_CATEGORIES_SUCCESS":
      return {
        ...state,
        errorGetActiveSubCategories: false,
        requestingGetActiveSubCategories: false,
        successfulGetActiveSubCategories: true,
        subCategoriesActive: action.value,
      };
    case "GET_ALL_ACTIVE_SUB_CATEGORIES_ERROR":
      return {
        ...state,
        errorGetActiveSubCategories: true,
        requestingGetActiveSubCategories: false,
        successfulGetActiveSubCategories: false,
        subCategoriesActive: []
      };
    case "RESET_SUBCATEGORIES":
      return initialState;
    default:
      return state;
  }
};

export default subCategoriesReducer;
